import { setPagination } from '../../../State/pagination';
import fetchItemDescriptions from '../../../Services/fetchItemDescriptions';

export default () => async (dispatch) => {

  dispatch(setPagination({ current: 1 }));
  dispatch(fetchItemDescriptions());
  
}